// extracted by mini-css-extract-plugin
export default {"productRange":"ProductRange_productRange__Sg0PW","inputContainer":"ProductRange_inputContainer__c2-Xb","clearInput":"ProductRange_clearInput__QMx1I"};